import { render, staticRenderFns } from "./Hitungsaldoawal.vue?vue&type=template&id=0658a3af&"
import script from "./Hitungsaldoawal.vue?vue&type=script&lang=js&"
export * from "./Hitungsaldoawal.vue?vue&type=script&lang=js&"
import style0 from "./Hitungsaldoawal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports